module.exports = __webpack_public_path__ + "static/media/Team 32 - Hi-Tech.f8a982cb.png";